// src/utils/securityId.js

const DAYS_IN_MONTH = {
    1: 31,
    2: 29, // no year context; allow up to 29
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31
};

export const securityIdRegex = /^(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[A-Za-z0-9]{4}$/;

/**
 * Validates the MMDD part of an 8-digit Security ID formatted as MMDDXXXX.
 *
 * Rules:
 * - Must be 8 digits overall (caller typically enforces)
 * - Month: 01-12
 * - Day: valid for month (Feb allows 01-29)
 * - Last 4 digits can be anything
 *
 * Returns an error message string when invalid; otherwise returns "".
 */
export function validateSecurityIdMmdd8(securityIdDigits) {
    const d = String(securityIdDigits || "").trim();

    // Only validate MMDD when we have exactly 8 digits.
    // Length/required validation should be handled elsewhere.
    if (!/^[A-Za-z0-9]{8}$/.test(d)) return "";

    const mm = Number(d.slice(0, 2));
    const dd = Number(d.slice(2, 4));

    if (!Number.isFinite(mm) || mm < 1 || mm > 12) {
        return "Security ID month must be between 01 and 12";
    }

    const maxDay = DAYS_IN_MONTH[mm] || 31;
    if (!Number.isFinite(dd) || dd < 1 || dd > maxDay) {
        const mmStr = String(mm).padStart(2, "0");
        const maxStr = String(maxDay).padStart(2, "0");
        return `Security ID day must be between 01 and ${maxStr} for month ${mmStr}`;
    }

    if (!securityIdRegex.test(d)) return "Security ID must be in format MMDDXXXX with letters or digits";

    return "";
}
